import { get, post } from './http-calls';

export const getAllBranch = async () => {
    let res = await get(`/Branches`, { useAuthToken: true });
    return res;
};
export const getStamps_List = async () => {
    let res = await get(`Branches/Stamps_List`, { useAuthToken: true });
    return res;
};

export const postStampData = async (data) => {
    let res = await post(`Branches/SetStampImage`, data, { useAuthToken: true });
    return res;
};

export const getBranchStamps_GetDetailsById = async (id) => {
    let res = await get(`Branches/BranchStamps_GetDetails?StampId=${id}`, { useAuthToken: true });
    return res;
};
